import {
  NewButton,
  NewButtonSize,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import Flex, { GAP_CLASS } from "components/Flex";
import { ALIGN_CLASS, DIRECTION_CLASS } from "components/Flex/Flex";
import { bool, func, string } from "prop-types";

import classes from "./CommentComposer.module.scss";
import MentionTextarea from "./MentionTextarea";

export const MAX_COMMENT_LENGTH = 5000;
const COUNTER_THRESHOLD = 200;

const CommentComposer = ({
  value,
  onChange,
  onSubmit,
  onCancel,
  placeholder = "Add a comment…",
  submitLabel = "Post",
  autoFocus = false,
}) => {
  const isOverLimit = value.length > MAX_COMMENT_LENGTH;
  const isSubmitDisabled = value.trim().length === 0 || isOverLimit;
  const remaining = MAX_COMMENT_LENGTH - value.length;
  const showCounter = remaining <= COUNTER_THRESHOLD;

  return (
    <Flex
      direction={DIRECTION_CLASS.column}
      alignItems={ALIGN_CLASS.stretch}
      gap={GAP_CLASS.GAP_200}
      className={classes["composer"]}
    >
      <MentionTextarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        ariaLabel={placeholder}
        autoFocus={autoFocus}
      />
      <Flex justifyContent="space-between" alignItems={ALIGN_CLASS.center}>
        {showCounter && (
          <span
            className={clsx(classes["counter"], {
              [classes["counter--over"]]: isOverLimit,
            })}
          >
            {isOverLimit
              ? `${-remaining} characters over the ${MAX_COMMENT_LENGTH} limit`
              : `${remaining} characters remaining`}
          </span>
        )}
        <Flex gap={GAP_CLASS.GAP_200} className={classes["actions"]}>
          {onCancel && (
            <NewButton
              variant={NewButtonVariant.l2}
              size={NewButtonSize.md}
              onClick={onCancel}
            >
              Cancel
            </NewButton>
          )}
          <NewButton
            variant={NewButtonVariant.l1}
            size={NewButtonSize.md}
            onClick={onSubmit}
            disabled={isSubmitDisabled}
          >
            {submitLabel}
          </NewButton>
        </Flex>
      </Flex>
    </Flex>
  );
};

CommentComposer.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
  onSubmit: func.isRequired,
  onCancel: func,
  placeholder: string,
  submitLabel: string,
  autoFocus: bool,
};

export default CommentComposer;
